import { MODULE_TREE, GLOBAL_NODES, ModuleTreeNode } from './moduleRegistry';

// Mirrors backend/src/config/moduleTreeUtils.ts — see that file for the full
// design rationale. Used by AuthContext/Sidebar (ADM-07d) to resolve per-node
// nav visibility the same way the backend resolves per-node permissions.

interface FlatNode {
  parentKey: string | null;
  moduleKey: string | null;
}

const buildFlatMap = (): Map<string, FlatNode> => {
  const map = new Map<string, FlatNode>();
  const walk = (node: ModuleTreeNode, parentKey: string | null, moduleKey: string | null) => {
    map.set(node.key, { parentKey, moduleKey });
    (node.children || []).forEach((child) => walk(child, node.key, moduleKey));
  };
  MODULE_TREE.forEach((mod) => walk(mod, null, mod.key));
  GLOBAL_NODES.forEach((node) => walk(node, null, null));
  return map;
};

let flatMap: Map<string, FlatNode> | null = null;
const getFlatMap = () => (flatMap ??= buildFlatMap());

export const getAncestorChain = (nodeKey: string): string[] => {
  const chain: string[] = [];
  let current: string | undefined = nodeKey;
  const map = getFlatMap();
  while (current) {
    chain.push(current);
    current = map.get(current)?.parentKey ?? undefined;
  }
  return chain;
};

export const getModuleForNode = (nodeKey: string): string | null => getFlatMap().get(nodeKey)?.moduleKey ?? null;
